import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

class TourManager extends React.Component {
  constructor(props) {
    super(props);
    this.handleSend = this.handleSend.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  handleRemove(e) {
    e.preventDefault();
    this.props.dispatchRemoveMemberFromGroup(this.props.member.group.id, this.props.member.id);
  }
  handleSend(e) {
    e.preventDefault();
    // this.props.sendToTourManager(this.props.tourId, { user: this.props.tourManager.id });
  }
  buildToolbar() {
    if (this.props.readOnly) {
      return null;
    }
    return (
      <span className="pull-right">
        <Button onClick={this.handleSend}><i className="fa fa-envelope" /></Button>
        <Button onClick={this.handleRemove}><i className="fa fa-trash" /></Button>
      </span>
    );
  }
  render() {
    const member = this.props.member;
    const toolbar = this.buildToolbar();
    if (member) {
      if (member.first_name) {
        return (
          <p className="clearfix">{member.first_name} {member.last_name} {toolbar}</p>
        );
      }
      return (<p className="clearfix">{member.email} {toolbar}</p>);
    }
    return (
      <p>
        Member missing.
      </p>
    );
  }
}
TourManager.propTypes = {
  tourId: PropTypes.number.isRequired,
  tourManager: PropTypes.object.isRequired,
  readOnly: PropTypes.bool.isRequired,
};
export default TourManager;



// WEBPACK FOOTER //
// src/routes/tours/components/TourManager.js